import { useContext } from "react";
import { AlertContext } from "../providers/AlertProvider";

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    // Prevent crash: show alert or log
    if (typeof window !== 'undefined' && window.alert) {
      window.alert("Alert system not available. Please refresh the page.");
    } else {
      console.warn("useAlert hook must be used with AlertProvider");
    }
    // Return no-op functions
    return {
      addAlert: () => {},
      removeAlert: () => {},
      showError: () => {},
      clearError: () => {},
      error: null,
    };
  }
  const { addAlert, removeAlert, showError, clearError, error } = context;
  return { addAlert, removeAlert, showError, clearError, error };
};
